/**
 * ONE query client for the app (docs/00-project-rules/07 §6): it owns the server cache and its
 * invalidation. It does NOT hold local state — a draft, a selected row and the open filter panel
 * stay in the components that own them.
 *
 * Retrying a 4xx is pointless (the request was wrong, or the session is gone) and a signed-out
 * reader must reach the sign-in screen fast, so only server-side and network failures retry.
 */
import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './httpClient.js';

const MINUTE = 60_000;

export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
  return failureCount < 2;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: MINUTE,
        gcTime: 10 * MINUTE,
        refetchOnWindowFocus: false,
        retry: shouldRetry,
      },
      mutations: { retry: false },
    },
  });
}
